import Icon from '../components/Icon.vue'

Icon.register({
  lemon: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M489 23C465.9-0.1 434.6-5.9 413.9 6.1 355 40.4 232.7-46.9 92.9 92.9S40.4 355 6.1 413.9C-5.9 434.6-0.1 465.9 23 489 46.1 512.1 77.4 517.9 98.1 505.9 157 471.6 279.3 558.9 419.1 419.1S471.6 157 505.9 98.1C517.9 77.4 512.1 46.1 489 23zM243.9 95.5C185.7 110.1 110.1 185.7 95.5 243.9 93.7 251.2 87.2 256 80 256 78.7 256 77.4 255.8 76.1 255.5 67.5 253.4 62.3 244.7 64.5 236.1 81.9 166.4 166.3 81.9 236.1 64.5 244.7 62.3 253.4 67.5 255.5 76.1S252.5 93.4 243.9 95.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lemon.js
// module id = Y3sj
// module chunks = 144